import no_document_icon from '../../../assets/images/no_document.png'
export const NoDataLoadingKqht = () => {
	return (
		<>
			<div className="box-loading" style={{margin : 0}}>
				<div id="loading-spinner" className="spinner">
					<img src={no_document_icon} width={32}/>
				</div>
				<p>Chưa có dữ liệu!</p>
				<p>Kết quả học tập của học sinh sẽ được cập nhật khi kết thúc học kỳ.</p>
			</div>
		</>
	);
};
